"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cookies = void 0;
var Cookies = /** @class */ (function () {
    function Cookies(prefix) {
        if (prefix === void 0) { prefix = ''; }
        this.prefix = prefix;
    }
    Cookies.prototype.getName = function (name) {
        /* for short id not used prefix */
        if (['shortId'].indexOf(name) >= 0) {
            return name;
        }
        return this.prefix ? "".concat(this.prefix, "_").concat(name) : name;
    };
    Cookies.prototype.set = function (name, value, days) {
        if (days === void 0) { days = 365; }
        var expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
        var cookieValue = encodeURIComponent(value);
        var cookieName = this.getName(name);
        document.cookie = "".concat(cookieName, "=").concat(cookieValue, "; expires=").concat(expires, "; path=/");
    };
    Cookies.prototype.get = function (name) {
        var value = "; ".concat(document.cookie);
        var cookieName = this.getName(name);
        var parts = value.split("; ".concat(cookieName, "="));
        if (parts.length === 2)
            return parts.pop().split(';').shift();
        return null;
    };
    Cookies.prototype.delete = function (name) {
        this.set(name, '', -1);
    };
    return Cookies;
}());
exports.Cookies = Cookies;
